import './input_description.css';

const InputDescription = ({ label, id, name, value, onChange, placeholder, rows = 4, dataSection, className = '' }) => {
    return (
        <div className={`base-input-container Campo ${className}`}>
            <label className="base-label" htmlFor={id}>{label}</label>
            <textarea
                id={id}
                name={name}
                data-section={dataSection}
                value={value}
                onChange={onChange}
                rows={rows}
                placeholder={placeholder}
                className="base-input-field" /* Or keep local override */
            ></textarea>
        </div>
    );
};

export default InputDescription;
